// @flow
import {
  DRAW_OVERLAY_TOGGLE_DRAW_MODE,
  DRAW_OVERLAY_CLEAR,
  DRAW_OVERLAY_SET_FEATURE,
  DRAW_OVERLAY_SET_MODE,
} from 'actions/drawOverlay';

const INITIAL_STATE = {
  appInDrawMode: false,
  drawToolsTourSeen: localStorage.draw_tools_tour_seen || false,
  mode: 'simple_select',
  feature: undefined,
};

export default function reduce(
  state = INITIAL_STATE,
  { type, mode, feature, appInDrawMode }
) {
  switch (type) {
    case DRAW_OVERLAY_TOGGLE_DRAW_MODE:
      return {
        ...state,
        appInDrawMode,
      };

    case DRAW_OVERLAY_CLEAR:
      return {
        ...state,
        feature: null,
      };

    case DRAW_OVERLAY_SET_FEATURE:
      return {
        ...state,
        feature,
      };

    case DRAW_OVERLAY_SET_MODE:
      return {
        ...state,
        mode,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/drawOverlay.js